import { COLOR_PALETTE, COLOR_PALETTE_CONTRAST, DATA_VISUALIZATION_HUE, DATA_VISUALIZATION_HUE_VARIANT } from './common';

/*
0 => represents all colors in the palette
2,3, ... ==> sequence of color appearance based on number of colors
contrast variants - Subtle/default/high
*/
export const DATA_VISUALIZATION_HUE_SEQUENCE = {
  [COLOR_PALETTE.CATEGORICAL]: {
    0: {
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.PLUM],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
      ],
    },
    2: {
      [COLOR_PALETTE_CONTRAST.SUBTLE]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
      ],
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
      ],
    },
    3: {
      [COLOR_PALETTE_CONTRAST.SUBTLE]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
      ],
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
      ],
    },
    4: {
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
      ],
      [COLOR_PALETTE_CONTRAST.HIGH]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
      ],
    },
    5: {
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.PLUM],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
      ],
      [COLOR_PALETTE_CONTRAST.HIGH]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.PLUM],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
      ],      
    },
    6: {
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.PLUM],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
      ],
      [COLOR_PALETTE_CONTRAST.HIGH]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.PLUM],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
      ],      
    },
  },
  [COLOR_PALETTE.VALUE]: {
    0: {
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.COBALT],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
      ],
    },
  },
  [COLOR_PALETTE.PERFORMANCE]: {
    0: {
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.GREEN],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.LIME],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.YELLOW],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.ORANGE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.RED],
      ],
    },
  },
  [COLOR_PALETTE.ALL]: {
    0: {
      [COLOR_PALETTE_CONTRAST.DEFAULT]: [
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.AQUA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.TEAL],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MARINE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.COBALT],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.BLUE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.PLUM],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.MAGENTA],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.PINK],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.RED],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.ORANGE],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.YELLOW],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.LIME],
        DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.GREEN],
      ],
    },
  },
};